
    import { IonBadge, IonIcon,IonNote,IonImg,IonItem, IonLabel,IonTitle,IonToolbar,IonHeader,IonMenuToggle,IonContent,IonMenu } from '@ionic/vue';
    import { computed, defineComponent } from 'vue';
    import { storeToRefs } from 'pinia';
    import { currentUserStore } from '@/stores/currentUser'
    import { useMensajesUnreadStore } from '@/stores/mensajesUnread';
    import userAuth from '@/composables/userAuth';
    import tools from "@/composables/tools";
import { calendarOutline, calculatorOutline, logoEuro, logoWhatsapp, personOutline, ribbonOutline, bagOutline, documentTextOutline, mailOutline } from 'ionicons/icons';
  
    export default defineComponent({
      components: { IonBadge, IonIcon,IonImg,IonNote,IonItem, IonLabel,IonTitle,IonToolbar,IonHeader,IonMenuToggle,IonContent,IonMenu},

      setup() {
        const currentUser = currentUserStore()
        const Auth = userAuth()
        const unreadStore = useMensajesUnreadStore()
        const { count: unreadCount } = storeToRefs(unreadStore)
        const unreadMenuBadge = computed(() => {
          const n = unreadCount.value
          return n > 99 ? '99+' : String(n)
        })

        const preload_Tarifas = () => {
          tools().setLog('Pulsa para ver tarifas')
        }

        const preload_Eventos = () => {
          tools().setLog('Pulsa para ver eventos')
        }

        const preload_Mensajes = () => {
          tools().setLog('Pulsa para ver mensajes')
        }

        const preload_Coordinadores = () => {
          tools().setLog('Pulsa para ver coordinadores')
        }

        const preload_Profesores = () => {
          tools().setLog('Pulsa para ver profesores')
        }

        const preload_Aulas = () => {
          tools().setLog('Pulsa para ver aulas')
        }

        const preload_Horarios = () => {
          tools().setLog('Pulsa para ver horarios')
        }

        const preload_Probar = () => {
          tools().setLog('Pulsa para ver horarios')
        }

        const preload_Calculadora = () => {
          tools().setLog('Pulsa para ver calculadora')
        }

        const preload_Recuperar = () => {
          tools().setLog('Pulsa para ver horarios')
        }
        const preload_Profile = () => {
          tools().setLog('Pulsa para ver si perfil personal')
        }

        const preload_Acreditacion = () => {
          tools().setLog('Pulsa para ver acreditación')
        }
                
        const asistencia = ()=>{
          window.open('whatsapp://send?phone=' + process.env.VUE_APP_WHATSAPP_HELP + '&text=' + encodeURI('Tengo problemas con la aplicación. ¿Puedes ayudarme?'))
          tools().setLog('Solicitaron ayuda','warning')
        }

        const abrirNormasEscuela = () => {
          tools().setLog('Pulsó en Normas de la escuela')
          const url = 'https://galidancia.com/normas/'
          const opened = window.open(url, '_blank')
          if (!opened) window.location.href = url
        }

        return {
          currentUser,
          Auth,
          userAuth,
          currentUserStore,
          preload_Probar,
          preload_Recuperar,
          preload_Horarios,
          preload_Tarifas,
          preload_Coordinadores,
          preload_Profesores,
          preload_Aulas,
          preload_Profile,
          preload_Acreditacion,
          preload_Eventos,
          preload_Mensajes,
          preload_Calculadora,
          calendarOutline,
          calculatorOutline,
          logoEuro,
          personOutline,
          logoWhatsapp,
          documentTextOutline,
          ribbonOutline,
          bagOutline,
          mailOutline,
          unreadCount,
          unreadMenuBadge,
          asistencia,
          abrirNormasEscuela,
          tools
        }
      },
    });
  